/* Home-only presets preserve native drawer, search and cart controls.
   PALLACIO: medidas (slide, logo do cabeçalho, título do slide) são lidas só ao carregar,
   redimensionar ou trocar de slide; na rolagem só entra a conta com scrollY, sem medir o DOM. */
(()=>{
 const controllers=new Map();
 function init(section){
  const header=section?.querySelector('[data-pallacio-home-preset]');
  if(!header)return;
  controllers.get(section)?.destroy();
  controllers.delete(section);
  const mark=section.querySelector('.pallacio-home-wordmark');
  let hero=document.querySelector('#main .shopify-section--slideshow');
  if(!mark||!hero)return;
  window.pallacioWordmarkControllers?.[section.id]?.destroy?.();
  window.pallacioStableHeader?.[section.id]?.destroy?.();
  const preset=header.dataset.pallacioHomePreset;
  let frame=0,measureFrame=0,filled=null,geo=null,lastKey='';

  function measure(){
   measureFrame=0;
   hero=document.querySelector('#main .shopify-section--slideshow');
   if(!hero||!section.isConnected){geo=null;return;}
   const sy=scrollY,w=innerWidth,m=w<700;
   const heroBottom=hero.getBoundingClientRect().bottom+sy;
   const real=section.querySelector('.header__logo-image:not(.header__logo-image--transparent)')||section.querySelector('.header__logo');
   const r=real?.getBoundingClientRect();
   const finalW=m?95:120;
   const title=hero.querySelector('.slideshow__slide.is-selected [data-pallacio-title-image] .pallacio-slide-title-image__scale');
   const tr=title?.getBoundingClientRect();
   geo={
    w,m,heroBottom,finalW,
    finalCX:r&&r.width?r.left+r.width/2:w/2,
    finalY:r&&r.height?r.top+r.height/2-finalW*.253555/2:(m?16:20),
    headerBottom:header.getBoundingClientRect().bottom,
    titleTop:tr&&tr.width>0&&tr.height>0?tr.top+sy:null
   };
   paint(true);
  }

  function paint(force){
   frame=0;
   if(!geo)return;
   const {w,m,heroBottom:h,finalW,finalCX,finalY,headerBottom,titleTop}=geo;
   const sy=scrollY;
   const progress=Math.max(0,Math.min(1,sy/Math.max(h*.72,1)));
   const p=progress*progress*(3-2*progress);
   const width=preset==='1'?(m?w*.94:Math.min(w*.20,320)):preset==='4'?(m?195:340):['3','7'].includes(preset)?(m?175:280):(m?190:270);
   const left=['3','4','7'].includes(preset);
   const startX=left?(m?16:32)+width/2:w/2-(preset==='1'?(m?6:10):0);
   const startY=preset==='1'?(m?48:20):16;
   let logoWidth=width+(finalW-width)*p;
   let x=startX+(finalCX-startX)*p,y=startY+(finalY-startY)*p;
   let iconY=preset==='1'&&m?32:y+logoWidth*.253555/2;
   // Fundo da marca grande calculado (posição fixa), sem medir o elemento.
   const markBottom=y+logoWidth*.253555;
   const boundary=Math.max(headerBottom,markBottom);
   const close=titleTop!==null&&(titleTop-sy)-boundary<=(filled?24:16);
   const isFilled=sy>=h-1||close;
   if(isFilled){logoWidth=finalW;x=finalCX;y=finalY;iconY=finalY+finalW*.253555/2;}
   const key=`${logoWidth.toFixed(2)}|${x.toFixed(2)}|${y.toFixed(2)}|${iconY.toFixed(2)}|${isFilled}`;
   if(!force&&key===lastKey)return;
   lastKey=key;
   section.classList.add('pallacio-preset-active');
   section.style.setProperty('--preset-logo-width',`${logoWidth}px`);
   section.style.setProperty('--preset-logo-x',`${x}px`);
   section.style.setProperty('--preset-logo-y',`${y}px`);
   section.style.setProperty('--preset-icon-y',`${iconY}px`);
   if(isFilled!==filled){
    filled=isFilled;
    section.classList.toggle('pallacio-preset-filled',filled);
    section.classList.toggle('pallacio-preset-left',left&&!filled);
    section.classList.toggle('pallacio-preset-separate',preset==='1'&&!filled);
    header.classList.toggle('is-filled',filled);
    header.dataset.pallacioVisualState=filled?'filled':'transparent';
   }
  }

  const schedule=()=>{if(!frame)frame=requestAnimationFrame(()=>paint(false))};
  const remeasure=()=>{if(!measureFrame)measureFrame=requestAnimationFrame(measure)};
  addEventListener('scroll',schedule,{passive:true});
  addEventListener('resize',remeasure);
  addEventListener('pageshow',remeasure);
  addEventListener('load',remeasure);
  document.fonts?.ready?.then(remeasure);
  measure();
  if(!matchMedia('(prefers-reduced-motion: reduce)').matches)mark.querySelector('.pallacio-home-wordmark__art')?.animate([{transform:'scale(1.08)',opacity:0},{transform:'scale(1)',opacity:1}],{duration:1100,easing:'ease-out'});
  controllers.set(section,{refresh:remeasure,destroy(){removeEventListener('scroll',schedule);removeEventListener('resize',remeasure);removeEventListener('pageshow',remeasure);removeEventListener('load',remeasure);cancelAnimationFrame(frame);cancelAnimationFrame(measureFrame)}});
 }
 const all=()=>document.querySelectorAll('.shopify-section--header').forEach(init);
 const refreshAll=()=>controllers.forEach(controller=>controller.refresh());
 if(document.readyState==='complete')all();else document.addEventListener('DOMContentLoaded',all,{once:true});
 document.addEventListener('carousel:change',e=>{if(e.target?.closest('.shopify-section--slideshow'))refreshAll()});
 document.addEventListener('load',e=>{if(e.target?.matches?.('.pallacio-slide-title-image__img'))refreshAll()},true);
 document.addEventListener('shopify:section:load',e=>{init(e.target);refreshAll()});
 document.addEventListener('shopify:section:unload',e=>{controllers.get(e.target)?.destroy();controllers.delete(e.target);refreshAll()});
 document.addEventListener('shopify:section:reorder',refreshAll);
})();
